import {
  IsUUID,
  IsString,
  IsEnum,
  IsOptional,
  IsEmail,
  IsDateString,
  ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

import {
  ClientsResponseInterface,
  ClientStatus,
} from '../../interface/clients/clients-response.interface';

import { MiniUsersDto } from '../users/users.dto';
import { CompanyDto } from '../companies/company.dto';

export class ClientsDto implements ClientsResponseInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsString()
  contact_person!: string | null;

  @IsOptional()
  @IsString()
  designation!: string | null;

  @IsOptional()
  @IsString()
  contact_number!: string | null;

  @IsOptional()
  @IsEmail()
  email!: string | null;

  @IsEnum(ClientStatus)
  status!: ClientStatus;

  @IsOptional()
  @IsDateString()
  created_at!: string | null;

  @IsOptional()
  @IsDateString()
  updated_at!: string | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  created_by!: MiniUsersDto | null;

  @IsOptional()
  @ValidateNested()
  @Type(() => MiniUsersDto)
  updated_by!: MiniUsersDto | null;

  @ValidateNested()
  @Type(() => CompanyDto)
  company!: CompanyDto;
}